import React, { useCallback, useContext, useEffect, useRef, useState } from 'react';
import Webcam from 'react-webcam';
import { LanguageContext } from '../../../shared/contexts/Language.context';
import CustomButton from '../../CustomButton/CustomButton';
import styles, { global } from './CamSnapshot.style';

export default function CamSnapshot({
  handleChange,
  theme,
  imageUrl,
  onSaveImage,
  onRetakeImage,
  setStreamRef,
}) {
  const { className: themeClassName, styles: themeStyle } = styles(theme);
  const webcamRef = useRef(null);
  const {
    state: { literals },
    actions: { translate },
  } = useContext(LanguageContext);
  const videoConstraints = {
    facingMode: { exact: 'environment' },
  };

  useEffect(() => {
    navigator.mediaDevices
      .getUserMedia({
        video: true,
      })
      .then(localMediaStream => {
        setStreamRef(localMediaStream);
      });
  }, []);

  const capture = useCallback(() => {
    const imageSrc = webcamRef.current.getScreenshot();
    console.log(webcamRef.current);
    fetch(imageSrc)
      .then(res => res.blob())
      .then(blob => {
        handleChange(blob);
      });
  }, [webcamRef, handleChange]);

  return (
    <div className={'video-container'} style={{ overflow: 'auto', maxHeight: '70vh' }}>
      {imageUrl ? (
        <div>
          <img
            src={imageUrl}
            alt="upload"
            className={`upload-img ${!imageUrl ? 'placeholder' : ''}`}
          />
        </div>
      ) : (
        <Webcam
          audio={false}
          ref={webcamRef}
          screenshotFormat="image/jpeg"
          screenshotQuality={1}
          videoConstraints={videoConstraints}
        />
      )}
      <div style={{ marginTop: 16 }}>
        {imageUrl ? (
          <div
            style={{
              justifyContent: 'center',
              flexDirection: 'column',
            }}
          >
            <CustomButton
              text={literals['guestForm.additionalDocument.uploadButton']}
              onClick={() => onSaveImage()}
              small={true}
            />
            <CustomButton
              text={literals['guestForm.additionalDocument.editButton']}
              onClick={() => onRetakeImage()}
              secondary={true}
              small={true}
            />
          </div>
        ) : (
          <CustomButton
            htmlType="submit"
            text={translate('guestForm.takePhoto')}
            onClick={!imageUrl ? capture : null}
          />
        )}
      </div>
      {themeStyle}
      <style jsx>{global}</style>
    </div>
  );
}
